module.exports = __webpack_public_path__ + "static/media/image2.bb3a8d76.jpeg";